module.exports = __webpack_public_path__ + "static/images/ui/ui-icons_a83300_256x240.png";